// extracted by mini-css-extract-plugin
export var actionButton = "_pa-0";
export var actionMenuContainer = "_pa-i";
export var bubble = "_pa-2";
export var bubbleActionMenu = "_pa-j";
export var bubbleContext = "_pa-6";
export var bubbleItems = "_pa-7";
export var customer = "_pa-3";
export var divider = "_pa-8";
export var fileList = "_pa-9";
export var hiddenComment = "_pa-o";
export var infoAbove = "_pa-a";
export var internal = "_pa-4";
export var lightActionButton = "_pa-1";
export var link = "_pa-b";
export var merchant = "_pa-5";
export var message = "_pa-c";
export var profilePicture = "_pa-e";
export var quillToolbarContainer = "_pa-f";
export var senderDate = "_pa-g";
export var senderDateCustomer = "_pa-h";
export var senderName = "_pa-d";
export var time = "_pa-k";
export var uploadedImage = "_pa-l";
export var username = "_pa-m";
export var xsmall = "_pa-n";